import { jsx as _jsx } from "react/jsx-runtime";
import { useCurrentStep } from '../hooks/useCurrentStep';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { usePreloadNextStepMessage } from '../hooks/usePreloadNextStepMessage';
import { useTracker } from '../tracking/useTracker';
import { useMessage } from './useMessage';

const MessagingContainer = () => {
  const {
    component: MessagingComponent
  } = useMessage();
  const Tracker = useTracker();
  const {
    currentStep
  } = useCurrentStep();
  usePreloadNextStepMessage();
  const {
    observedElementRef
  } = useIntersectionObserver(entry => {
    const percentage = parseInt(entry.intersectionRatio.toPrecision(1), 2);
    Tracker.messagingScrolling(currentStep, percentage * 100);
  });
  return MessagingComponent ? /*#__PURE__*/_jsx("div", {
    className: "MessagingContainer",
    ref: observedElementRef,
    children: /*#__PURE__*/_jsx(MessagingComponent, {})
  }) : null;
};

export default MessagingContainer;